import clsx from "clsx";
import { useYbugApi } from "ybug-react";

const Beta = ({
  error = false,
  showBugReport = true,
  message = "This is a new feature exclusive to Mob members. It's still a work in progress, so let us know if you spot anything that doesn't look right.",
}) => {
  const YbugContext = useYbugApi();
  const YbugApi = YbugContext?.Ybug;
  return (
    <div className={clsx("flex flex-col print:hidden")}>
      <span className="mr-auto inline-flex rounded-lg rounded-b-none bg-cobalt-500 px-4 py-1.5 text-xs uppercase tracking-wide text-white">
        {error ? "Uh-oh!" : "New Feature"}
      </span>

      <div className="flex flex-col gap-4 rounded-lg rounded-tl-none border border-cobalt-500 bg-white p-4">
        <div className={clsx("body-text-sm")}>
          <p>
            {error
              ? `Unfortunately we were unable to load this feature. This feature is still a work in progress, so we would appreciate you reporting a bug below.`
              : message}
          </p>
        </div>
        {showBugReport && (
          <div>
            <button
              onClick={() => {
                if (YbugApi) {
                  YbugApi.open("feedback");
                }
              }}
              data-ybug="open"
              className="inline-flex items-center gap-3 rounded bg-cobalt-500 px-4 py-2 font-body text-sm text-white transition-colors hover:bg-zinc-950"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                x="0"
                y="0"
                viewBox="0 0 16 16"
                className="h-3 w-auto"
              >
                <path
                  fill="currentColor"
                  d="M16 4V3h-2v1c0 .6-.4 1-1 1h-1c-.3-.4-.6-.7-1-1V3c0-1.7-1.3-3-3-3S5 1.3 5 3v1c-.4.3-.7.6-1 1H3c-.6 0-1-.4-1-1V3H0v1c0 1.7 1.3 3 3 3h.1c-.1.3-.1.7-.1 1H0v2h3v1c-1.7 0-3 1.3-3 3v1h2v-1c0-.6.4-1 1-1h.4c.8 1.8 2.6 3 4.6 3s3.8-1.2 4.6-3h.4c.6 0 1 .4 1 1v1h2v-1c0-1.7-1.3-3-3-3v-1h3V8h-3c0-.3 0-.7-.1-1h.1c1.7 0 3-1.3 3-3z"
                ></path>
              </svg>
              <span>Report a bug</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Beta;
